module.exports = __webpack_public_path__ + "img/cdw.8c94b796.png";